import { useEffect, useState } from "react";

interface PagedResult<T> {
	pageRows: T[];
	page: number;
	pageCount: number;
	setPage: (page: number) => void;
}

// Slices `rows` into pages of `pageSize`. Omitting pageSize (or passing a
// size >= rows.length) disables pagination and returns everything as one page.
export function usePagedRows<T>(rows: T[], pageSize?: number): PagedResult<T> {
	const [page, setPage] = useState(1);

	useEffect(() => {
		setPage(1);
	}, [rows]);

	if (!pageSize || rows.length <= pageSize) {
		return { pageRows: rows, page: 1, pageCount: 1, setPage };
	}

	const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
	const safePage = Math.min(Math.max(1, page), pageCount);
	const start = (safePage - 1) * pageSize;

	return {
		pageRows: rows.slice(start, start + pageSize),
		page: safePage,
		pageCount,
		setPage,
	};
}
